import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { IndexHeader } from "@/components/IndexHeader";
import { contentRender } from "@/libs/contentRender";

@Component({
    components: {
        IndexHeader
    }
})
export default class NotesContent extends Vue {
    private noteContentdata: any = {};
    @Prop() readonly noteContent: any;
    @Prop() readonly currentSection: any;
    mounted() {
        this.noteContentdata = contentRender(this.noteContent);
    }
    @Watch("noteContent")
    getNoteContent(n) {
        this.noteContentdata = contentRender(n);
    }
}

//@ts-ignore
export { default as NotesContent } from "./index.vue";
